// import { dataTool } from "echarts";
import React from "react";
export default function CompleteModal(props) {
  let { closeModal, showFeedbackMandatory, question, handleFeedbackInput, answersList, submitFeedback, surveyScreenData, afterSubmitData } = props;

  function matchFeedback(answersList1, question1) {
    let value = "";
    if (answersList1 && answersList1.length > 0) {
      let getIndex1 = answersList1.findIndex(item => item.questionId === question1.id);
      if (getIndex1 !== -1) {
        value = answersList1 && answersList1[getIndex1] && answersList1[getIndex1].feedback ? answersList1[getIndex1].feedback : "";
      }
    }
    return value
  }


  let showTextField = false;

  if (answersList && answersList.length > 0) {
    let getIndex = answersList.findIndex(prev => prev.questionId === question.id);
    if (getIndex !== -1) {

      if (answersList && answersList[getIndex] && answersList[getIndex]["multiAnswer"] && answersList[getIndex]["multiAnswer"].length > 0) {
        console.log("multiAnswer-------->",answersList[getIndex]["multiAnswer"])

        let getIndexOpt = answersList[getIndex]["multiAnswer"].findIndex(prev => prev.optionAns === "Others (please specify)");
        if (getIndexOpt !== -1) {
          showTextField = true
        }
      }

    }
  }

  console.log("showTextField-------->",showTextField)

  return (
    <>

      {showTextField? 
          <div className="">
            <div className="flex justify-between">
              <div/>
              <div className="text-red-500 text-xs p-2">{showFeedbackMandatory?"Text field is mandatory*":""}</div>
            </div>
            <textarea type="text" name="remark" value={matchFeedback(answersList, question)}
              onChange={(event) => handleFeedbackInput(event, question)}
              placeholder="Write Text.." className="w-full bg-gray-100 rounded-md p-3 text-sm border placeholder-gray-500 outline-none resize-y " >
            </textarea>
          </div> 
 
        : null}  

    </>
  );
}
